<div class="wrapper">

  <!-- Preloader -->
  <!-- <div class="preloader flex-column justify-content-center align-items-center">
      <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
    </div> -->

  <!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <!-- Left navbar links -->
  <div class="navbar-nav w-100 d-flex align-items-center">
      <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>

      <!-- Centered logo -->
      <div class="flex-grow-1 d-flex justify-content-center" style="margin-left: -60px;">
        <img src="assets/dmk.png" style="width: 50px; height: auto;" alt="MyRoots Logo">
      </div>
  </div>
</nav>

  <!-- /.navbar -->

  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-primary elevation-4" style="position: fixed;">
    <!-- Brand Logo -->
    <!-- <a style="display: inline-flex;padding-top: 10px;
      padding-left: 80px;color:#015792;">
      <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2" style="opacity: .8;width:40px;height:40px;">
      <span class="brand-text " style="margin-left: 10px;margin-top:15px;"></span>
    </a> -->


    <!-- Sidebar -->
    <!-- <div class="sidebar" style="height: calc(100vh - 85px); overflow-y: auto;"> -->
      <!-- Sidebar user panel (optional) -->
      <!-- <div class="user-panel mt-3 d-flex"> -->
        <!-- <div class="image">
                    <img src="assets/user-icon.png" class="img-circle elevation-2" alt="User Image">
                </div> -->
        <!-- <div class=" "> -->
          <a style="display: flex; align-items: center; padding: 10px 20px; color:#015792;">
            <img src="assets/dmk.png" alt="Admin Logo" style="width: 40px; height: auto;">
            <span class="brand-text" style="margin-left: 15px; font-weight: bold; font-size: 18px;">STUDENT</span>
          </a>
        <!-- </div>
      </div> -->
      <div class="sidebar" style="height: calc(100vh - 85px); overflow-y: auto;">
      <!-- SidebarSearch Form -->
      <!-- <div class="form-inline">
          <div class="input-group" data-widget="sidebar-search">
            <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div> -->

      <!-- Sidebar Menu -->
      <nav class="mt-3">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false"
          style="height:100%;">
          <li class="nav-item">
            <a [routerLink]="['stdashboard']" class="nav-link" data-widget="pushmenu">
              <i class="" style="display: flex; align-items: center;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black" d="M5 20V9.5l7-5.288L19 9.5V20h-5.192v-6.385h-3.616V20z" />
                </svg></i>
              <p style="margin-left:8px;color:black">
                Dashboard
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['stcourse']" class="nav-link" data-widget="pushmenu">
              <i class=""style="display: flex; align-items: center;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H8V4h12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z" />
                </svg></i>
              <p style="margin-left:8px;color:black">
                Enrolled Courses
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['studentgrouprequestlist']" class="nav-link" data-widget="pushmenu">
              <i class="fas fa-user-graduate"  style="color: #0c0c0c;display: flex; align-items: center;"></i>
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H8V4h12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z" />
                </svg></i> -->
              <p style="margin-left:8px;color:black">
                Request a Course
              </p>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a [routerLink]="['studentgrouprequestlist']" class="nav-link" data-widget="pushmenu">
              <i class="fas fa-user-graduate"  style="color: #0c0c0c;"></i> -->
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H8V4h12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z" />
                </svg></i> -->
                <!-- <img src="https://cdn-icons-png.flaticon.com/512/2501/2501145.png" width="20" height="20" alt="Group free icon" title="Group free icon">
              <p style="margin-left:8px;color:black">
                Student Group Request Course
              </p>
            </a>
          </li> --> 
          <li class="nav-item">
            <a [routerLink]="['mentorstudentcourse']" class="nav-link" data-widget="pushmenu">
              <i class="" style="display: flex; align-items: center;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H8V4h12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z" />
                </svg></i>
              <p style="margin-left:8px;color:black">
                Available Courses
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['studentFeedback']" class="nav-link" data-widget="pushmenu">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7 12h-2v-2h2zm0-4h-2V6h2z" />
                </svg>
              </i>
              <p style="margin-left: 8px;color:black">
                Student Feedback
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['stchangePassword']" class="nav-link" data-widget="pushmenu">
              <i class="" style="display: flex; align-items: center;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3" />
                </svg></i>
              <p style="margin-left: 8px;color:black">
                Change Password
              </p>
            </a>
          </li>
          <li class="nav-item" style="cursor: pointer;">
            <a class="nav-link" [routerLink]="" (click)="studentDelete()" data-widget="pushmenu">
              <i class="" style="display: flex; align-items: center;">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16">
                  <path
                    d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                  <path
                    d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708" />
                </svg>
              </i>
              <p style="margin-left: 8px;color:#000;">
                Close Account
              </p>
            </a>
          </li>


          <li class="nav-item">
            <a class="nav-link">
              <i class="" style="display: flex; align-items: center;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33a1 1 0 0 0 0-.76a1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" />
                </svg></i>
              <p style="margin-left: 8px;color:black" (click)="signout()">
                Sign Out
              </p>
            </a>
          </li>

        </ul>

      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <!--  -->
    <!-- /.content-header -->
    <div style="min-height: 600px;">
      <router-outlet></router-outlet>
    </div>
    <div class="container disclaimer">
      <div class="row">
          <div class="col-lg-12 col-12 ">
              <strong>DISCLAIMER:</strong>
          </div>
          <div class="col-lg-12 col-12 paragraph">
              <ul>
                  <li>This service is provided free of charge by the DMK Engineering Wing for students of Tamil Nadu.</li>
                  <li>Personal details, such as photos or addresses, should not be shared, except for WhatsApp contact information.</li>
                  <li>No fees should be collected under any circumstances.</li>
                  <li>The course can be modified / canceled at any time.</li>
              </ul>
          </div>
      </div>
  </div>
  

    <div class="footer">
      <div class="text-center p-3">
        <p>Copyright © MyRoots. Developed by <a  target="_blank"><strong>RedMind Technologies</strong></a> {{footerdate}}</p>
        <p>
          <i class="fa fa-phone" style="font-size:16px"></i>
          <strong> 7200749261</strong>
        </p>
      </div>
    </div>
    <!-- /.content-wrapper -->
    <!-- <footer class="main-footer">
      <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
      All rights reserved.
      <div class="float-right d-none d-sm-inline-block">
        <b>Version</b> 3.2.0
      </div>
    </footer> -->

    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Control sidebar content goes here -->
    </aside>
    <!-- /.control-sidebar -->
  </div>